var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import PropTypes from 'prop-types';
import React, { createContext, Component } from 'react';
import Checkbox from './checkbox';
import cs from '../_util/classNames';
import { ConfigConsumer } from '../ConfigProvider';
var Group = /** @class */ (function (_super) {
    __extends(Group, _super);
    function Group(props) {
        var _this = _super.call(this, props) || this;
        _this.onChange = function (optionValue, checked) {
            var value = _this.state.value.slice();
            if (checked) {
                value.push(optionValue);
            }
            else {
                value.splice(value.indexOf(optionValue), 1);
            }
            if (!('value' in _this.props)) {
                _this.setState({
                    value: value,
                });
            }
            _this.props.onChange && _this.props.onChange(value);
        };
        _this.renderGroup = function (_a) {
            var getPrefixCls = _a.getPrefixCls;
            var _b = _this.props, disabled = _b.disabled, _c = _b.options, options = _c === void 0 ? [] : _c, style = _b.style, className = _b.className, error = _b.error, children = _b.children;
            var value = _this.state.value;
            var prefixCls = getPrefixCls('checkbox');
            var classNames = cs(prefixCls + "-group", className, {
                error: error,
            });
            return (React.createElement("span", { className: classNames, style: style }, children ? (React.createElement(CheckboxGroupContext.Provider, { value: {
                    isCheckboxGroup: true,
                    checkboxGroupValue: value,
                    onGroupChange: _this.onChange,
                    disabled: disabled,
                } }, children)) : (options.map(function (option) {
                if (typeof option === 'object') {
                    return (React.createElement(Checkbox, { disabled: disabled || option.disabled, checked: value && value.indexOf(option.value) !== -1, onChange: _this.onChange.bind(_this, option.value), key: option.value, value: option.value }, option.label));
                }
                return (React.createElement(Checkbox, { disabled: disabled, checked: value && value.indexOf(option) !== -1, onChange: _this.onChange.bind(_this, option), key: option, value: option }, option));
            }))));
        };
        var value;
        if (props.value && props.value.length) {
            value = props.value;
        }
        else if (props.defaultValue && props.defaultValue.length) {
            value = props.defaultValue;
        }
        _this.state = {
            value: value || [],
        };
        return _this;
    }
    Group.getDerivedStateFromProps = function (nextProps) {
        if ('value' in nextProps) {
            return {
                value: nextProps.value || [],
            };
        }
        return null;
    };
    Group.prototype.render = function () {
        return React.createElement(ConfigConsumer, null, this.renderGroup);
    };
    Group.propTypes = {
        style: PropTypes.object,
        className: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
        defaultValue: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.string),
            PropTypes.arrayOf(PropTypes.number),
        ]),
        value: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.string),
            PropTypes.arrayOf(PropTypes.number),
        ]),
        options: PropTypes.oneOfType([
            PropTypes.arrayOf(PropTypes.string),
            PropTypes.arrayOf(PropTypes.number),
            PropTypes.arrayOf(PropTypes.object),
        ]),
        disabled: PropTypes.bool,
        error: PropTypes.bool,
        onChange: PropTypes.func,
    };
    Group.defaultProps = {
        style: {},
        options: [],
        defaultValue: [],
    };
    return Group;
}(Component));
export var CheckboxGroupContext = createContext({
    isCheckboxGroup: false,
    checkboxGroupValue: [],
    onGroupChange: function () { },
});
export default Group;
